import { mutatorAction } from "satcheljs";
import { getStore as composeStore } from "owa-mail-compose-store";

const setNewMessageCreationInProgressMutator: (newMessageCreationInProgress: boolean) => void = mutatorAction("setNewMessageCreationInProgress", function setNewMessageCreationInProgress(newMessageCreationInProgress: boolean): void {
    composeStore().newMessageCreationInProgress = newMessageCreationInProgress;
});
export default setNewMessageCreationInProgressMutator;
